<template>
  <!-- needed ref="thead" to eliminate the vuesax error -->
  <tbody ref="thead">
    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in rows">
      <vs-td>
        <div v-if="tr.logoUrl" class="con-vs-avatar w-12 h-12" style="background: rgb(195, 195, 195);"><!---->
          <div class="con-img vs-avatar--con-img" :style="{ background: 'url(' + tr.logoUrl + ') no-repeat center / cover' }"></div>
        </div>
      </vs-td>
      <vs-td>{{ tr.name }}</vs-td>
      <vs-td class="whitespace-no-wrap">
        <feather-icon
          icon="EditIcon"
          svgClasses="w-5 h-5 hover:text-primary stroke-current"
        />
        <feather-icon
          @click.prevent.stop="deleteBranding(tr)"
          icon="TrashIcon"
          svgClasses="ml-3 w-5 h-5 hover:text-primary stroke-current"
        />
      </vs-td>
    </vs-tr>
  </tbody>
</template>

<script>
export default {
  props: ['rows'],
  methods: {
    clicktr (tr) {
      this.$emit('selected', tr);
    }, // needed to eliminate the error this.$parent.clicktr
    deleteBranding (tr) {
      this.$store.dispatch('visitManagement/deleteBrandById', tr.id);
    }
  }
}
</script>
